import "vant/lib/toast/style";
import _Toast from "vant/lib/toast";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import Nav from "@/components/nav/navBar.vue";
import purpleButton from "@/components/purpleButton/purpleButton.vue";
import inputFiled from "@/components/inputFiled/inputFiled.vue";
import selectBirthday from "@/components/selectBirthday/selectBirthday.vue";
import selectGender from "@/components/selectGender/selectGender.vue";
import pickerInput from '@/components/pickerInput/pickerInput.vue';
import { horoscopeIdex } from "@/utils/horoscopeUtil";
import { i18n } from "@/i18n/i18n-setup";
import { getLang } from '@/api/utils/apiHelper';
import { sendMapEvent } from "@/utils/analytics";

var NameBirthdayGender =
/*#__PURE__*/
function (_Vue) {
  _inherits(NameBirthdayGender, _Vue);

  function NameBirthdayGender() {
    var _this;

    _classCallCheck(this, NameBirthdayGender);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NameBirthdayGender).apply(this, arguments));
    _this.isShowSelectDay = false;
    _this.birthdayStr = i18n.t("infomation.birthday") + ' MM-DD';
    _this.birthdayHolder = i18n.t("infomation.birthday") + ' MM-DD';
    _this.genderStr = i18n.t("infomation.gender");
    _this.genderhodler = i18n.t("infomation.gender");
    _this.nickNameHolder = i18n.t("infomation.nick_name");
    _this.isShowSelectGender = false;
    _this.horoScopeName = '';
    _this.inputText = '';
    _this.birthdayMonth = 0;
    _this.birthdayDay = 0;
    _this.isShow = false;
    return _this;
  }

  _createClass(NameBirthdayGender, [{
    key: "titleLang",
    value: function titleLang(val) {
      var titleStr = val.includes('&') ? val.replace(" & ", "_").toLowerCase() : val.replace(" ", "_").toLowerCase();
      return this.isChinese ? this.$t("home_page.main_function_list." + titleStr) : " " + this.$t("home_page.main_function_list." + titleStr) + " ";
    }
  }, {
    key: "contentTextLang",
    value: function contentTextLang(val) {// return (this.$t('info_mask.provide_info') + this.titleLang(val) + this.$t('info_mask.reprot'))
    }
  }, {
    key: "goBack",
    value: function goBack() {
      // const backNum = routerIncludeTimes("personalFutrue");
      this.routerGoBack(-1);
    }
  }, {
    key: "showBirthdayMask",
    value: function showBirthdayMask(value) {
      this.isShowSelectDay = value.isShow;
      this.horoScopeName = value.horoScopeName;

      if (value.birthdayStr) {
        this.birthdayStr = value.birthdayStr;
        this.birthdayMonth = value.birthdayMonth;
        this.birthdayDay = value.birthdayDay;
      }
    }
  }, {
    key: "showGenderMask",
    value: function showGenderMask() {
      this.isShowSelectGender = !this.isShowSelectGender;
    }
  }, {
    key: "getMyResult",
    value: function getMyResult() {
      if (this.inputText === '') {
        _Toast(this.$t("toast.input_nickname"));

        if (this.functionType) {
          sendMapEvent("uia_fill_in_Palmistry", {
            'failed': "not_input_name"
          });
        }

        return;
      }

      if (this.birthdayStr === i18n.t("infomation.birthday") + ' MM-DD') {
        _Toast(this.$t("toast.input_birthday"));

        if (this.functionType) {
          sendMapEvent("uia_fill_in_Palmistry", {
            'failed': "not_select_birthday"
          });
        }

        return;
      }

      if (this.genderStr === i18n.t("infomation.gender") && this.genderShow) {
        _Toast(this.$t("toast.input_gender"));

        if (this.functionType) {
          sendMapEvent("uia_fill_in_Palmistry", {
            'failed': "not_select_gender"
          });
        }

        return;
      }

      this.updateUserMsg({
        nickName: this.inputText,
        birthday: this.birthdayStr,
        gender: this.genderStr,
        birthdayMonth: this.birthdayMonth,
        birthdayDay: this.birthdayDay,
        horoScopeName: this.horoScopeName
      });
      console.log('this.horoScopeName', this.horoScopeName);
      this.$emit('get-my-report', {
        nickName: this.inputText,
        birthdayStr: this.birthdayStr,
        birthdayMonth: this.birthdayMonth,
        birthdayDay: this.birthdayDay,
        horoScopeIndex: horoscopeIdex[this.horoScopeName],
        gender: this.genderStr
      });
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      var userMsg = this.getterUserMsg;

      if (userMsg) {
        this.inputText = userMsg.nickName;
        this.birthdayStr = userMsg.birthday ? userMsg.birthday : i18n.t("infomation.birthday") + ' MM-DD';
        this.horoScopeName = userMsg.horoScopeName ? userMsg.horoScopeName : '';
        this.genderStr = userMsg.gender ? userMsg.gender : i18n.t("infomation.gender");
        this.birthdayMonth = userMsg.birthdayMonth ? userMsg.birthdayMonth : 0;
        this.birthdayDay = userMsg.birthdayDay ? userMsg.birthdayDay : 0;
      }

      setTimeout(function () {
        _this2.isShow = true;

        if (_this2.functionType) {
          sendMapEvent("uia_fill_in_Palmistry", {
            key: "show"
          });
        }
      }, 3000);
    }
  }, {
    key: "getResultLang",
    get: function get() {
      return this.$t("common.button.get_my_relust");
    }
  }, {
    key: "isChinese",
    get: function get() {
      return getLang().includes('zh');
    }
  }, {
    key: "enterLive",
    get: function get() {
      return this.isShow ? 'slide-enter-active' : 'slide-leave-active';
    }
  }]);

  return NameBirthdayGender;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], NameBirthdayGender.prototype, "routerGoBack", void 0);

tslib_1.__decorate([Prop()], NameBirthdayGender.prototype, "title", void 0);

tslib_1.__decorate([Prop()], NameBirthdayGender.prototype, "functionType", void 0);

tslib_1.__decorate([Prop({
  default: true
})], NameBirthdayGender.prototype, "genderShow", void 0);

tslib_1.__decorate([Getter(types.GETTER_USER_MSG)], NameBirthdayGender.prototype, "getterUserMsg", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_USER_MSG)], NameBirthdayGender.prototype, "updateUserMsg", void 0);

NameBirthdayGender = tslib_1.__decorate([Component({
  components: {
    Nav: Nav,
    selectBirthday: selectBirthday,
    purpleButton: purpleButton,
    inputFiled: inputFiled,
    selectGender: selectGender,
    pickerInput: pickerInput
  }
})], NameBirthdayGender);
export default NameBirthdayGender;